// created from 'create-ts-index'

export * from './suelos-core-detail.model';
export * from './suelos-core-form.model';
export * from './suelos-core.model';
